import styled from 'styled-components';

const StyledSwitch = styled.label`
  display: inline-block;
  height: 32px;
  position: relative;
  width: 64px;

  .checkbox {
    display: none;
  }

  .checkbox:checked + .slider {
    background-color: ${props => (props.enabledColor === '' ? (props.theme && props.theme.iconColor) : props.enabledColor)};
  }

  .checkbox:checked + .slider:before {
    transform: translateX(32px);
  }

  .rounded {
    border-radius: 32px;
  }

  .rounded:before {
    border-radius: 50%;
  }
`;

export default StyledSwitch;
